import React from "react";

const LoadingIndicator = () => {
  return (
    <div className="loading-indicator">
      <span>Loading...</span>
    </div>
  );
};

export default LoadingIndicator;
